

declare global {
    interface Window {
        env: any;
    }
}


export const APPLICATION = window.env.APPLICATION
export const API_URL = window.env.API_URL